import '../layouts/ansysoft.css';
import logo from '../assets/webbull-logo-final.png'

import React, { useState, useEffect, useRef } from 'react';
import { Link, NavLink } from 'react-router-dom';

function Nav() {

    // const [isScroll, setIsScroll] = useState(false);

    // useEffect(() => {
    //     const handleScroll = () => {
    //         // console.log("Scroll position:", window.scrollY);
    //         if (window.scrollY > 0) {
    //             setIsScroll(true);
    //         }
    //         else {
    //             setIsScroll(false);
    //         }
    //     };

    //     window.addEventListener("scroll", handleScroll);

    //     return () => {
    //         window.removeEventListener("scroll", handleScroll);
    //     };
    // }, [isScroll]);

    // useEffect(()=>{
    //     const handelScroll = () => {

    //         if(window.scrollY > 0)
    //         {
    //             SetIsScroll(true);
    //         }
    //         else{
    //             SetIsScroll(false);
    //         }
    //     }

    //     window.addEventListener("scroll", handelScroll);

    //     return() => {
    //         window.removeEventListener("scroll", handelScroll);
    //     }

    // },[]);



    // navbar burger menu OnClicked and Unclicked


    const [isMenuOpen, setIsMenuOpen] = useState(false);
    const menuRef = useRef(null);

    const UpdateMenu = () => {
        setIsMenuOpen((prevState) => !prevState);
    };

    const closeMenu = () => {
        setIsMenuOpen((prevState) => !prevState);
    }

    const handleClickOutside = (e) => {
        if (menuRef.current && !menuRef.current.contains(e.target)) {
            setIsMenuOpen(false); // Close the menu if click is outside the menu
        }
        // console.log(e.target)
    };

    // Add and remove event listener for clicks outside
    useEffect(() => {
        document.addEventListener("mousedown", handleClickOutside);
        return () => {
            document.removeEventListener("mousedown", handleClickOutside);
        };
    }, []);


    return (
        <>
            <nav className={`navbar navbar-expand-lg sNavbar`} id="mainNavbar">
                <div className="container">
                    {/* Preload the LCP image with a high fetchpriority so it starts loading with the stylesheet.  */}
                    {/* <NavLink rel="preload" fetchpriority="high" as="image" to="/home" type="image/webp"/> */}

                    {/* the logo of the navbar */}
                    {/* srcset="../assets/logo.webp 160w, ../assets/logo-big.webp 260w" */}

                    <NavLink className="navbar-brand me-0 me-md-0 me-xl-5" id="no-border1" to="/app/home">
                        <img src={logo} alt="WebBull Logo" title="WebBull" />
                    </NavLink>
                    <button onClick={UpdateMenu} className="navbar-toggler" id="no-border2" type="button" data-bs-toggle="collapse"
                        data-bs-target="#navbarSupportedContent" aria-controls="navbarSupportedContent" aria-expanded="false"
                        aria-label="Toggle navigation">
                        <span className="navbar-toggler-icon text-white hampbar"><i className="fa-solid fa-bars fa-xl"></i></span>
                    </button>
                    <div className={`${isMenuOpen ? "show" : "collapse navbar-collapse"} `} id="navbarSupportedContent">
                        <ul className="navbar-nav me-auto mb-2 mb-lg-0 ms-3 ms-md-2 text-white gap-3">
                            <li className="nav-item">
                                <NavLink className="nav-link" aria-current="page" to="/app/home" ><span
                                    className="nav-link-text">Home</span></NavLink>
                            </li>
                            <li className="nav-item">
                                <NavLink className="nav-link" to="/app/ourcommunity" ><span className="nav-link-text">Our Community</span></NavLink>
                            </li>
                            <li className="nav-item">
                                <NavLink className="nav-link" to="/app/aboutus"><span className="nav-link-text">About Us</span></NavLink>
                            </li>
                            <li className="nav-item">
                                <NavLink className="nav-link" to="/app/faq"><span className="nav-link-text">FAQ</span></NavLink>
                            </li>
                            {/* <li className="nav-item">
                                <NavLink className="nav-link" to="/app/business-plan"><span className="nav-link-text">Business
                                    Plan</span></NavLink>
                            </li> */}
                            
                            <li className="nav-item d-block d-md-none">
                                <NavLink className="nav-link" to="/signin"><span className="nav-link-text">Become an
                                    Entrepreneur</span></NavLink>
                            </li>
                        </ul>
                        <div className="d-flex d-none d-md-block">
                            <Link className="nav-btn" to="/signin">Become an Entrepreneur</Link>
                        </div>
                    </div>
                </div>
            </nav>
        </>
    )

}

export default Nav;